"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWebphoneReplyMessageOption = exports.WEBPHONE_REPLY_TYPE = exports.WEBPHONE_REPLY_TIMEUNIT = exports.extractHeadersData = exports.camelize = void 0;
var Session_1 = require("ringcentral-call-control/lib/Session");
var STRING_CAMELIZE_REGEXP_1 = /(\-|\_|\.|\s)+(.)?/g;
var STRING_CAMELIZE_REGEXP_2 = /(^|\/)([A-Z])/g;
function camelize(key) {
    return key
        .replace(STRING_CAMELIZE_REGEXP_1, function (match, separator, chr) {
        return chr ? chr.toUpperCase() : '';
    })
        .replace(STRING_CAMELIZE_REGEXP_2, function (match, separator, chr) {
        return match.toLowerCase();
    });
}
exports.camelize = camelize;
function extractHeadersData(headers) {
    var partyData;
    var callId;
    if (headers &&
        headers['P-Rc-Api-Ids'] &&
        headers['P-Rc-Api-Ids'][0] &&
        headers['P-Rc-Api-Ids'][0].raw) {
        /**
         * interface PartyData {
         *  "partyId": String,
         *  "sessionId": String
         * }
         *
         * INFO: partyId is ID of the participant in current Session. Mostly it represents User on the call,
         * it could be active participant (talking right now) or already disconnected User,
         * e.g. who made a transfer to another person.
         * To identify the User who owns the party you need to find owner.extensionId within party.
         */
        partyData = headers['P-Rc-Api-Ids'][0].raw
            .split(';')
            .map(function (sub) { return sub.split('='); })
            .reduce(function (accum, _a) {
            var key = _a[0], value = _a[1];
            accum[camelize(key)] = value;
            return accum;
        }, {}) || {};
    }
    if (headers &&
        headers['Call-ID'] &&
        headers['Call-ID'][0] &&
        headers['Call-ID'][0].raw) {
        callId = headers['Call-ID'][0].raw;
    }
    return [partyData, callId];
}
exports.extractHeadersData = extractHeadersData;
exports.WEBPHONE_REPLY_TIMEUNIT = {
    Minute: 0,
    Hour: 1,
    Day: 2
};
exports.WEBPHONE_REPLY_TYPE = {
    customMessage: 0,
    callBack: 1,
    onMyWay: 2,
    inAMeeting: 5,
};
function getWebphoneReplyMessageOption(params) {
    if (params.replyWithText) {
        return {
            replyType: exports.WEBPHONE_REPLY_TYPE.customMessage,
            replyText: params.replyWithText,
        };
    }
    if (params.replyWithPattern.pattern === Session_1.ReplyWithPattern.onMyWay) {
        return {
            replyType: exports.WEBPHONE_REPLY_TYPE.onMyWay,
        };
    }
    if (params.replyWithPattern.pattern === Session_1.ReplyWithPattern.inAMeeting) {
        return {
            replyType: exports.WEBPHONE_REPLY_TYPE.inAMeeting,
        };
    }
    var replyType = exports.WEBPHONE_REPLY_TYPE.callBack;
    var callbackDirection;
    if (params.replyWithPattern.pattern.indexOf('CallMe')) {
        callbackDirection = 1;
    }
    else {
        callbackDirection = 0;
    }
    return {
        replyType: replyType,
        timeValue: params.replyWithPattern.time,
        timeUnits: exports.WEBPHONE_REPLY_TIMEUNIT[params.replyWithPattern.timeUnit],
        callbackDirection: callbackDirection,
    };
}
exports.getWebphoneReplyMessageOption = getWebphoneReplyMessageOption;
//# sourceMappingURL=utils.js.map